import React, { useState } from 'react';
import Tabs from './Tabs/Tabs';
function Dashboard() {
    const [selectedCardType, setSelectedCardType] = useState('');

    return (
        <div className='wrp_dashboard'>
            <Tabs onCardSelect={setSelectedCardType} />
        </div>
    );
}

export default Dashboard;
